import { useState } from "react";
import { Plus, ShoppingBag, Briefcase, Calendar, User, Search, MessageCircle } from "lucide-react";
import { useNavigate } from "react-router-dom";
import BottomNavigation from "@/components/BottomNavigation";
import FunctionTile from "@/components/FunctionTile";
import { useUser } from "@/contexts/UserContext";

const IndexFixed = () => {
  const [activeTab, setActiveTab] = useState('home');
  const { user } = useUser();
  const navigate = useNavigate();

  const handleTabChange = (tab: string) => {
    setActiveTab(tab);
    switch (tab) {
      case 'home':
        navigate('/');
        break;
      case 'marketplace':
        navigate('/marketplace');
        break;
      case 'berichten':
        navigate('/berichten');
        break;
      case 'vacatures':
        navigate('/vacatures');
        break;
      case 'profiel':
        navigate('/profiel');
        break;
    }
  };

  const mainFunctions = [
    {
      title: "WOM Plaza",
      description: "Ontdek diensten en producten van vrouwen",
      icon: Search,
      onClick: () => {
        console.log("Navigating to WOM Plaza");
        navigate('/marketplace');
      }
    },
    {
      title: "Berichten",
      description: "Chat met andere vrouwen over diensten en projecten",
      icon: MessageCircle,
      onClick: () => {
        console.log("Navigating to Messages");
        navigate('/berichten');
      }
    },
    {
      title: "Dienst Plaatsen",
      description: "Deel je diensten met de bewuste vrouwen gemeenschap",
      icon: Plus,
      onClick: () => {
        console.log("Navigating to Post Service form");
        navigate('/dienst-plaatsen');
      }
    },
    {
      title: "Product Toevoegen",
      description: "Plaats je bewuste producten te koop",
      icon: ShoppingBag,
      onClick: () => {
        console.log("Navigating to Add Product form");
        navigate('/product-toevoegen');
      }
    },
    {
      title: "Vacatures Bekijken",
      description: "Ontdek kansen bij bewuste bedrijven",
      icon: Briefcase,
      onClick: () => {
        console.log("Navigating to Vacancies list");
        navigate('/vacatures');
      }
    },
    {
      title: "Afspraken Beheren",
      description: "Plan en bekijk je afspraken en boekingen",
      icon: Calendar,
      onClick: () => {
        console.log("Navigating to Appointments");
        navigate('/afspraken');
      }
    },
    {
      title: "Mijn Profiel",
      description: "Bekijk en bewerk je profielinformatie",
      icon: User,
      onClick: () => {
        console.log("Navigating to Profile");
        navigate('/profiel');
      }
    }
  ];

  return (
    <div style={{ 
      minHeight: '100vh',
      backgroundColor: '#f6f1eb' // beige-100 from Angela's reference
    }}>
      {/* Main Content */}
      <div className="px-6 pt-16 pb-32">
        {/* Welcome Section */}
        <div className="max-w-2xl mx-auto text-center mb-12">          
          {/* Hero Section - Clean Professional */}
          <div style={{
            backgroundColor: '#fbf8f4', // beige-50
            borderColor: '#efe7dd', // beige-200
            border: '1px solid',
            borderRadius: '8px',
            padding: '32px',
            marginBottom: '32px',
            boxShadow: '0 1px 2px 0 rgb(0 0 0 / 0.05)'
          }}>
            <div className="mb-6">
              <h1 className="text-5xl md:text-6xl font-light text-gray-900 mb-2 tracking-wider">
                <span className="font-bold" style={{ color: '#a0897c' }}>W</span>
                <span className="mx-2" style={{ color: '#d9cbbf' }}>·</span>
                <span className="font-bold" style={{ color: '#a0897c' }}>O</span>
                <span className="mx-2" style={{ color: '#d9cbbf' }}>·</span>
                <span className="font-bold" style={{ color: '#a0897c' }}>M</span>
              </h1>
              <p className="text-xl font-medium mb-6" style={{ color: '#a0897c' }}>
                Woman on a Mission
              </p>

              <p className="text-lg font-normal leading-relaxed" style={{ color: '#b6a092' }}>
                Voor vrouwen die hun dromen waarmaken,<br />
                hun passie delen en samen groeien
              </p>
            </div>
          </div>

          <div style={{
            backgroundColor: '#efe7dd', // beige-200
            borderColor: '#e6dbd0', // beige-300
            border: '1px solid',
            borderRadius: '8px',
            padding: '24px',
            marginBottom: '32px'
          }}>
            <p className="font-medium text-lg" style={{ color: '#837069' }}>
              Ready om je mission te starten?
            </p>
          </div>
        </div>

        {/* Function Cards */}
        <div className="max-w-2xl mx-auto space-y-4">
          {mainFunctions.map((func, index) => (
            <FunctionTile
              key={index}
              title={func.title}
              description={func.description}
              icon={func.icon}
              onClick={func.onClick}
              className="w-full"
            />
          ))}
        </div>
      </div>

      {/* Bottom Navigation */}
      <BottomNavigation activeTab={activeTab} onTabChange={handleTabChange} />
    </div>
  );
};

export default IndexFixed;